import React, { useState } from "react";
import { Modal, Input, Button, Pagination, Select } from "antd";
import { Plus } from "lucide-react";

const Physical = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentBook, setCurrentBook] = useState(null);
    const [issueDetails, setIssueDetails] = useState({ 
        memberType: '',
        memberId: '',
        dateIssued: '', 
        dueDate: '',
        returnDate: '' 
    });
    const [newBookDetails, setNewBookDetails] = useState({
        bookId: '',
        title: '',
        authors: '',
        publisher: '',
        edition: '',
        isbnNumber: '',
        category: '',
        type: '',
        language: '',
        publicationYear: '',
        numberOfPages: '',
        format: '',
        shelfLocation: {
            rack: '',
            row: '',
            section: ''
        },
        vendorName: '',
        purchaseDate: '',
        coverImage: null,
        details: ''
    });
    const [isAddBookModalOpen, setIsAddBookModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 8;

    // Mock member data for dropdown
    const memberOptions = [
        { value: 'STU001', label: 'John Doe (STU001)' },
        { value: 'TEA001', label: 'Jane Smith (TEA001)' },
        { value: 'OTH001', label: 'Bob Wilson (OTH001)' }
    ];

    const dataBook = [
        {
            coverImage: 'https://img.pikbest.com/origin/09/02/31/51cpIkbEsTn3E.jpg!w700wp',
            title: 'my book',
            issued: false,
            details: null
        },
        {
            coverImage: 'https://img.pikbest.com/origin/09/02/31/51cpIkbEsTn3E.jpg!w700wp',
            title: 'my book 2',
            issued: true,
            details: {
                memberType: 'Student',
                memberId: 'STU001',
                dateIssued: '2023-01-01',
                dueDate: '2023-01-15',
                returnDate: '2023-01-14',
            }
        },
    ];

    const filteredBooks = dataBook.filter(book =>
        book.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleImageClick = (book) => {
        setCurrentBook(book);
        setIsModalOpen(true);
        if (!book.issued) {
            setIssueDetails({ 
                memberType: '',
                memberId: '',
                dateIssued: '', 
                dueDate: '',
                returnDate: '' 
            });
        }
    };

    const handleIssueChange = (e) => {
        const { name, value } = e.target;
        setIssueDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleMemberTypeChange = (value) => {
        setIssueDetails(prev => ({ ...prev, memberType: value }));
    };

    const handleMemberIdChange = (value) => {
        setIssueDetails(prev => ({ ...prev, memberId: value }));
    };

    const handleSubmitIssue = () => {
        console.log("Issuing book to:", issueDetails);
        setIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setIssueDetails({ 
            memberType: '',
            memberId: '',
            dateIssued: '', 
            dueDate: '',
            returnDate: '' 
        });
    };

    const handleAddBook = () => {
        setIsAddBookModalOpen(true);
        setNewBookDetails({
            bookId: '',
            title: '',
            authors: '',
            publisher: '',
            edition: '',
            isbnNumber: '',
            category: '',
            type: '',
            language: '',
            publicationYear: '',
            numberOfPages: '',
            format: '',
            shelfLocation: {
                rack: '',
                row: '',
                section: ''
            },
            vendorName: '',
            purchaseDate: '',
            coverImage: null,
            details: ''
        });
    };

    const handleNewBookChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setNewBookDetails(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setNewBookDetails(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmitNewBook = () => {
        console.log("Adding new book:", newBookDetails);
        setIsAddBookModalOpen(false);
    };

    const totalBooks = filteredBooks.length;
    const paginatedBooks = filteredBooks.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <>
            <div className="mb-4 row">
                <div className="col-10">
                    <Input
                        type="text"
                        placeholder="Search by title"
                        className="p-2 border rounded w-full"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="col-2">
                    <div className="flex space-x-2 w-100">
                        <button
                            className="flex items-center justify-center flex-1 bg-[#241763] text-white p-2 rounded space-x-2"
                            onClick={handleAddBook}
                        >
                            <Plus className="h-4 w-4" />
                            <span>Add Book</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {paginatedBooks.map((book, index) => (
                    <div key={index} className="border rounded w-[90%] h-[300px]">
                        <img
                            src={book.coverImage}
                            alt={book.title}
                            className={`w-100 h-100 mb-2 cursor-pointer ${book.issued ? 'opacity-50 bg-black' : ''}`}
                            onClick={() => handleImageClick(book)}
                        />
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-center">
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalBooks}
                onChange={(page) => setCurrentPage(page)}
                className="mt-4"
            />
            </div>

            <Modal
                title={currentBook?.issued ? `Details for ${currentBook.title}` : `Issue ${currentBook?.title}`}
                visible={isModalOpen}
                onCancel={handleCloseModal}
                footer={[
                    <Button key="close" onClick={handleCloseModal} className="bg-[#EDEBF1] text-[#463C77]">Close</Button>,
                    !currentBook?.issued && (
                        <Button key="submit" onClick={handleSubmitIssue} className="bg-[#463C77] text-white">Submit</Button>
                    )
                ]}
            >
                {currentBook?.issued ? (
                    <div className="p-3">
                        <p>Member Type: {currentBook.details.memberType}</p>
                        <p>Member ID: {currentBook.details.memberId}</p>
                        <p>Date Issued: {currentBook.details.dateIssued}</p>
                        <p>Due Date: {currentBook.details.dueDate}</p>
                        <p>Return Date: {currentBook.details.returnDate}</p>
                    </div>
                ) : (
                    <div className="p-3">
                        <label htmlFor="memberType" className="block mb-1">Member Type</label>
                        <Select
                            name="memberType"
                            placeholder="Select Member Type"
                            value={issueDetails.memberType}
                            onChange={handleMemberTypeChange}
                            className="w-full mb-2"
                            options={[
                                { value: 'Student', label: 'Student' },
                                { value: 'Teacher', label: 'Teacher' },
                                { value: 'Other', label: 'Other' }
                            ]}
                        />

                        <label htmlFor="memberId" className="block mb-1">Member ID</label>
                        <Select
                            showSearch
                            name="memberId"
                            placeholder="Search Member ID"
                            value={issueDetails.memberId}
                            onChange={handleMemberIdChange}
                            className="w-full mb-2"
                            options={memberOptions}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        />

                        <label htmlFor="dateIssued" className="block mb-1">Issue Date</label>
                        <Input
                            type="date"
                            name="dateIssued"
                            value={issueDetails.dateIssued}
                            onChange={handleIssueChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="dueDate" className="block mb-1">Due Date</label>
                        <Input
                            type="date"
                            name="dueDate"
                            value={issueDetails.dueDate}
                            onChange={handleIssueChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="returnDate" className="block mb-1">Return Date</label>
                        <Input
                            type="date"
                            name="returnDate"
                            value={issueDetails.returnDate}
                            onChange={handleIssueChange}
                            className="p-2 border rounded w-full mb-2"
                        />
                    </div>
                )}
            </Modal>

            <Modal
                title="Add New Book"
                visible={isAddBookModalOpen}
                onCancel={() => setIsAddBookModalOpen(false)}
                width={800}
                footer={[
                    <Button key="close" onClick={() => setIsAddBookModalOpen(false)} className="bg-[#EDEBF1] text-[#463C77]">Close</Button>,
                    <Button key="submit" onClick={handleSubmitNewBook} className="bg-[#463C77] text-white">Submit</Button>
                ]}
            >
                <div className="p-3 grid grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="bookId" className="block mb-1">Book ID</label>
                        <Input
                            type="text"
                            name="bookId"
                            placeholder="Book ID"
                            value={newBookDetails.bookId}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="title" className="block mb-1">Title</label>
                        <Input
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={newBookDetails.title}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="authors" className="block mb-1">Author(s)</label>
                        <Input
                            type="text"
                            name="authors"
                            placeholder="Authors"
                            value={newBookDetails.authors}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="publisher" className="block mb-1">Publisher</label>
                        <Input
                            type="text"
                            name="publisher"
                            placeholder="Publisher"
                            value={newBookDetails.publisher}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="edition" className="block mb-1">Edition</label>
                        <Input
                            type="text"
                            name="edition"
                            placeholder="Edition"
                            value={newBookDetails.edition}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="isbnNumber" className="block mb-1">ISBN/ISSN Number</label>
                        <Input
                            type="text"
                            name="isbnNumber"
                            placeholder="ISBN/ISSN Number"
                            value={newBookDetails.isbnNumber}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="type" className="block mb-1">Type</label>
                        <Select
                            name="type"
                            value={newBookDetails.type}
                            onChange={(value) => handleNewBookChange({ target: { name: 'type', value }})}
                            className="w-full mb-2"
                            options={[
                                { value: 'book', label: 'Book' },
                                { value: 'dvd', label: 'DVD' }
                            ]}
                        />

                        <label htmlFor="category" className="block mb-1">Genre/Category</label>
                        <Input
                            type="text"
                            name="category"
                            placeholder="Category"
                            value={newBookDetails.category}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />
                    </div>

                    <div>
                        <label htmlFor="language" className="block mb-1">Language</label>
                        <Input
                            type="text"
                            name="language"
                            placeholder="Language"
                            value={newBookDetails.language}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="publicationYear" className="block mb-1">Publication Year</label>
                        <Input
                            type="number"
                            name="publicationYear"
                            placeholder="Publication Year"
                            value={newBookDetails.publicationYear}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="numberOfPages" className="block mb-1">Number of Pages</label>
                        <Input
                            type="number"
                            name="numberOfPages"
                            placeholder="Number of Pages"
                            value={newBookDetails.numberOfPages}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="format" className="block mb-1">Book Format</label>
                        <Select
                            name="format"
                            value={newBookDetails.format}
                            onChange={(value) => handleNewBookChange({ target: { name: 'format', value }})}
                            className="w-full mb-3"
                            options={[
                                { value: 'hardcover', label: 'Hardcover' },
                                { value: 'paperback', label: 'Paperback' },
                                { value: 'ebook', label: 'E-Book' }
                            ]}
                        />

                        <label className="block mb-1">Shelf Location</label>
                        <div className="grid grid-cols-3 gap-2 mb-2">
                            <Input
                                placeholder="Rack"
                                name="shelfLocation.rack"
                                value={newBookDetails.shelfLocation.rack}
                                onChange={handleNewBookChange}
                            />
                            <Input
                                placeholder="Row"
                                name="shelfLocation.row"
                                value={newBookDetails.shelfLocation.row}
                                onChange={handleNewBookChange}
                            />
                            <Input
                                placeholder="Section"
                                name="shelfLocation.section"
                                value={newBookDetails.shelfLocation.section}
                                onChange={handleNewBookChange}
                            />
                        </div>

                        <label htmlFor="vendorName" className="block mb-1">Vendor Name</label>
                        <Input
                            type="text"
                            name="vendorName"
                            placeholder="Vendor Name"
                            value={newBookDetails.vendorName}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="purchaseDate" className="block mb-1">Purchase Date</label>
                        <Input
                            type="date"
                            name="purchaseDate"
                            value={newBookDetails.purchaseDate}
                            onChange={handleNewBookChange}
                            className="p-2 border rounded w-full mb-2"
                        />

                        <label htmlFor="coverImage" className="block mb-1">Cover Image</label>
                        <Input
                            type="file"
                            name="coverImage"
                            onChange={(e) => setNewBookDetails(prev => ({ ...prev, coverImage: e.target.files[0] }))}
                            className="p-2 border rounded w-full mb-2"
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default Physical;